const US_PHONE_DIGITS = 11
const INDIA_PHONE_DIGITS = 12
const US_PHONE_PREFIX = "1"
const INDIA_PHONE_PREFIX = "9"
const PLUS = "+"
const PHONE_DEFAULT_ERROR_MSG = "Please input correct Phone Number"
export const NICK_NAME_MAX_LENGTH = 15
export const CART_PARTNER_NAME_ELIPSIS_LENGTH = 8

const PhoneInputConstants = {
  US_PHONE_DIGITS,
  INDIA_PHONE_DIGITS,
  US_PHONE_PREFIX,
  INDIA_PHONE_PREFIX,
  PLUS,
  PHONE_DEFAULT_ERROR_MSG,
}

export default PhoneInputConstants
